// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2bh5m","choiceBoxes":"toolbarselects_choiceBoxes__CFa_A","simpleField":"toolbarselects_simpleField__3xZBu"};